import { Dispatch } from "redux";
import { ACTIONS } from "./types";

export const setApiBaseUrl = (apiBaseUrl: string) => async (dispatch: Dispatch) => {
    dispatch({
        type: ACTIONS.SET_API_BASE_URL,
        payload: apiBaseUrl,
    });
};
